import { render, staticRenderFns } from "./EditUser.vue?vue&type=template&id=159f4770&"
import script from "./EditUser.vue?vue&type=script&lang=ts&"
export * from "./EditUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports